import axios from "axios";
import {
  APIService,
  getCarrierName,
  PAYMENT_KEYS,
} from "../utilities/Constants";
import { ErrorHandler, handleApiError } from "./utils/errorUtils";
import { HeaderConfig } from "./utils/headerUtils";
import { apiPost } from "./utils/apiUtils";
import { messages } from "../../src/resources/strings";
import { getBundleId } from "react-native-device-info";

export const createPaymentAccessToken = async (
  policyNumber: string,
  payorId: string,
  originPaymentPortal: string,
  origin: string,
) => {
  const customErrorHandlers: ErrorHandler[] = [
    {
      case: 401,
      onError: () => {
        return { errorCode: messages.error.sessionExpired };
      },
    },
  ];

  try {
    const response = await apiPost(
      APIService.harmony,
      `/policy/${policyNumber}/payment-${origin}/token/${payorId}/${originPaymentPortal}`,
      {
        userRole: PAYMENT_KEYS.userRole,
        paymentCategory: PAYMENT_KEYS.paymentCategory,
        feeContext: PAYMENT_KEYS.feeContext,
        amountContext: PAYMENT_KEYS.amountContext,
        clientReferenceData2: PAYMENT_KEYS.clientReferenceData2,
        // sourceName: PAYMENT_KEYS.sourceName,
        bundleId: getBundleId(),
        policySource: getCarrierName(),
      },
      { isUserAuthRequired: true },
      customErrorHandlers,
      undefined,
      { policySource: getCarrierName(), withCredentials: true } as HeaderConfig,
    );

    if (response.status === 200) {
      return response?.data?.result;
    } else {
      return {
        errorCode: response?.message || response?.errorCode,
      };
    }
  } catch (error: any) {
    handleApiError(error, customErrorHandlers);
  }
};
